import { createStore, createEvent, createEffect } from 'effector';
import { TELEGRAM_CONFIG } from '../config/telegramConfig';

// Типы для состояний MainButton
export type MainButtonState = 'initial' | 'hidden' | 'terms' | 'terms_inactive'| 'contact' | 'contact_inactive' | 'scan' | 'scan_inactive' | 'get_reward' | 'waiting_reward';

// События
export const setMainButtonState = createEvent<MainButtonState>();
export const setMainButtonText = createEvent<string>();
export const setMainButtonAction = createEvent<() => void>();
export const setMainButton = createEvent<MainButtonStore>();

// Глобальная переменная для хранения текущего действия
let currentAction: (() => void) | null = null;
let currentState: MainButtonState = 'initial';
let hasGlobalHandler = false;

// Эффект для обновления MainButton
export const updateMainButtonFx = createEffect<{
  state: MainButtonState;
  text: string;
  action: () => void;
}, void>(({ state, text, action }) => {
  const telegramWebApp = window.Telegram?.WebApp;
  if (!telegramWebApp?.MainButton) return;

  console.log(`Updating MainButton: state=${state}, text=${text}, action=${action.name || 'anonymous'}`);

  // Сохраняем текущее состояние и действие
  currentState = state;
  currentAction = action;

  if (state === 'hidden') {
    telegramWebApp.MainButton.hide();
    return;
  }

  // Устанавливаем текст
  telegramWebApp.MainButton.setText(text);
  
  // Устанавливаем цвет в зависимости от состояния
  if (state.includes('inactive')) {
    telegramWebApp.MainButton.color = '#757575'; // Серый цвет для неактивной кнопки
    telegramWebApp.MainButton.disable();
  } else {
    telegramWebApp.MainButton.color = TELEGRAM_CONFIG.mainButtonColor; // Синий цвет для активной кнопки
    telegramWebApp.MainButton.enable();
  }
  
  // Устанавливаем глобальный обработчик только один раз
  if (!hasGlobalHandler) {
    telegramWebApp.MainButton.onClick(() => {
      console.log(`MainButton clicked: state=${currentState}, text=${text}, action=${currentAction?.name || 'anonymous'}`);
      if (currentAction) {
        currentAction();
      }
    });
    hasGlobalHandler = true;
  }
  
  telegramWebApp.MainButton.show();
});

export type MainButtonStore = {
  state: MainButtonState;
  text: string;
  action: (() => void) | null;
};
// Store
export const mainButtonStore = createStore<MainButtonStore>({
  state: 'initial',
  text: '',
  action: null,
})
  .on(setMainButtonState, (state, newState) => ({ ...state, state: newState }))
  .on(setMainButtonText, (state, text) => ({ ...state, text }))
  .on(setMainButtonAction, (state, action) => ({ ...state, action }))
  .on(setMainButton, (state, newState) => ({ ...state, ...newState }));

// Обновляем MainButton при изменении store
mainButtonStore.watch(({ state, text, action }) => {
  if (action) {
    updateMainButtonFx({ state, text, action });
  }
});
